import { useState, type FormEvent } from 'react';
import { api } from '../api.js';
import { useApp } from '../state.js';

export default function Login(): JSX.Element {
  const setAuthenticated = useApp((s) => s.setAuthenticated);
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/api/auth/login', { password });
      setAuthenticated(true);
    } catch (err: any) {
      setError(err?.status === 429 ? 'Muitas tentativas. Espere alguns minutos.' : 'Senha incorreta.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center">
      <form className="login" onSubmit={submit}>
        <h1 style={{ margin: 0 }}>Caderno Vivo</h1>
        <p className="muted small" style={{ margin: 0 }}>Entre para abrir os seus cadernos.</p>
        <input
          type="password" value={password} autoFocus autoComplete="current-password"
          placeholder="Senha" onChange={(e) => setPassword(e.target.value)}
        />
        {error ? <p className="small" style={{ color: 'var(--danger)', margin: 0 }}>{error}</p> : null}
        <button className="primary" type="submit" disabled={busy || !password}>
          {busy ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
